import { createEvent, createStore } from 'effector';

const SESSION_KEY = 'onboarding_isReturningUser';

function readStoredIsReturningUser(): boolean | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return null;
  } catch {
    return null;
  }
}

function writeStoredIsReturningUser(value: boolean | null) {
  try {
    if (value === null) sessionStorage.removeItem(SESSION_KEY);
    else sessionStorage.setItem(SESSION_KEY, String(value));
  } catch {
    // Ignore quota / private-mode failures — the store still works for the current page.
  }
}

/** Persists the verified account type across refreshes within the current onboarding attempt. */
export const setIsReturningUser = createEvent<boolean | null>();
export const resetOnboardingSession = createEvent();

export const onboardingSessionStore = createStore<{ isReturningUser: boolean | null }>({
  isReturningUser: readStoredIsReturningUser(),
})
  .on(setIsReturningUser, (state, isReturningUser) => ({ ...state, isReturningUser }))
  .on(resetOnboardingSession, () => ({ isReturningUser: null }));

setIsReturningUser.watch(writeStoredIsReturningUser);
resetOnboardingSession.watch(() => writeStoredIsReturningUser(null));
